import auth from "@/services/ExerciseInitAuth"

const list = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/questions/`, {
    params: query
  });

const remove = ID =>
  auth.delete(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/`)

const get = ID =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/`)

const put = (ID, data) =>
  auth.put(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/`, data)

const create = data =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/questions/`, data);

const getPage = (query, ID) =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/page/`, { params: query });

const uploadSubtitlesNl = (ID, file = null) =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/subtitles/nl/`, file);

const uploadSubtitlesEn = (ID, file = null) =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/subtitles/en/`, file);

const uploadVideo = (ID, file = null) =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/questions/${ID}/video/`, file);

export default {
  list,
  remove,
  get,
  create,
  put,
  getPage,
  uploadSubtitlesNl,
  uploadSubtitlesEn,
  uploadVideo
}
